import React, { useEffect, useState } from "react";
import { FaUser } from "react-icons/fa";
import flag_2 from "./../../assets/img/tarh-parcham-iran-psdtarh2.png";
import MainLayout from "../../layout/main";
import { HistoryItem } from "../../component/historyItem";
import { ApiEndpoints, useApiCall } from "../../api";
import Loading from "../../component/loading";
import { useAppNavigation } from "../../router/routes";
import { toDateString } from "../../helper/dateHelper";
import { RiCheckDoubleLine } from "react-icons/ri";
import { useValidation, ValidationTypes } from "../../helper/validation";
import { useAlert } from "react-alert";
import { UserRoles } from "../../storage/enums";
import { storageApi } from "../../storage/storageApi";
// import { redirect, useNavigate } from "react-router-dom";

const ProgramDetailPage = () => {
  const { navigate, queryParameter, params } = useAppNavigation();
  const programId = params().id;
  const alert = useAlert();
  const [status, setStatus] = useState("");
  const [description, setDescription] = useState("");
  const userProfile = storageApi.useGetUser();
  /*
                      {
                              type: ValidationTypes.stringMaxLength,
                              options: {
                                length: 80,
                              },
                            },
                            {
                              type: ValidationTypes.stringMinLength,
                              options: {
                                length: 5,
                              },
                            },
                            {
                          name: "description",
                          label: "توضیحات",
                          value: description,
                          validations: [
                            {
                              type: ValidationTypes.stringRequired,
                            },
            
                          ],
                        },
                      */
  const { errors, validate, removeError } = useValidation([
    {
      name: "status",
      label: "وضعیت",
      value: status,
      validations: [
        {
          type: ValidationTypes.stringRequired,
        },
      ],
    },
  ]);
  const isAdmin = () => {
    return userProfile.role == "state_manager";
  };
  const [
    [programTypeList, subjectList, activityList, programNameList],
    { loading: formLoading },
  ] = useApiCall({
    endpoints: [
      ApiEndpoints.docs.programTypeList,
      ApiEndpoints.docs.subjectList,
      ApiEndpoints.docs.activityList,
      ApiEndpoints.docs.programNameList,
    ],
  });

  const [[history], { loading: historyLoading }] = useApiCall({
    endpoints: ApiEndpoints.program.history,
    payload: {
      programId,
    },
  });

  const [, { loading: adminReplyLoading, fetch: createAdminReply }] =
    useApiCall({
      endpoints: ApiEndpoints.program.adminReply,
      lazy: true,
    });

  const [[eventList], { loading: eventLoading }] = useApiCall({
    endpoints: ApiEndpoints.events.list,
  });

  useEffect(() => {
    if (!eventLoading && !historyLoading) {
      const eventId = history?.data
        ?.find((c) => c.program_info)
        ?.program_info?.monasebat?.toString();

      setSelectedEvent(
        eventList?.data?.find((c) => c.id.toString() === eventId),
      );
    }
  }, [eventLoading, historyLoading]);

  const [selectedEvent, setSelectedEvent] = useState(null);

  const submitForm = async () => {
    const { isValid } = validate();
    console.log("description>>>", description);
    if (!isValid) {
      return alert.error("لطفا خطا های فرم را برطرف کنید");
    }
    // if(!description) {
    //   setErrors({
    //     description: "فیلد توضیحات الزامی میباشد",
    //     status: status
    //   });
    // }
    // if(!status) {
    //   setErrors({
    //     description: description,
    //     status: "انتخاب فیلد وضعیت الزامی می‌باشد"
    //   });
    // }

    // if(!errors.description && !errors.status) {
    const [createAdminResponse] = await createAdminReply({
      status,
      description,
      programId,
    });

    if (createAdminResponse.isOk) {
      return navigate("/program/list");
    }
    //}
  };

  if (formLoading || eventLoading) {
    return (
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
        <div className="sec1 w-full bg-greenblue-light h-auto rounded-3xl relative p-8">
          <Loading isLoading={true} color={"blue"} center />
        </div>
      </div>
    );
  }

  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
        {/* sec1 */}
        <div className="sec1 w-full bg-greenblue-light h-auto rounded-3xl relative p-8">
          <img src={flag_2} className=" absolute left-0 top-0 h-32" />
          <div className="flex flex-col gap-8 justify-center items-center w-[60%] mx-auto">
            <div>
              {selectedEvent && (
                <p className="text-center">
                  مناسبت :<span> {selectedEvent?.title} </span>
                  <span className={"opacity-80 mx-2"}>|</span>
                  تاریخ :
                  <span>
                    {" "}
                    {toDateString(selectedEvent?.date, "jYYYY/jMM/jDD")}{" "}
                  </span>
                </p>
              )}
            </div>
          </div>
        </div>
        {isAdmin() && (
          <div className="text-white text-sm rounded-xl p-4 w-full max-w-[900px] mx-auto bg-gray-200 border-2 border-slate-300">
            <textarea
              type="text"
              placeholder="توضیحات"
              className={` rounded-lg p-4 border-[1.5px]  w-full text-sm pl-8 mt-2 text-black ${errors.description && "border-red-600"}`}
              rows="5"
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
                removeError("description");
              }}
            ></textarea>
            {errors["description"] && (
              <p className={"text-sm mt-2 text-red-600"}>
                {errors["description"]}
              </p>
            )}
            <div className="mb-4">
              <label className="text-black ml-2" htmlFor="status">
                وضعیت:
              </label>
              <select
                id="status"
                onChange={(e) => {
                  setStatus(e.target.value);
                  removeError("status");
                }}
                className=" w-[200px] p-3 rounded-lg text-black mt-2"
              >
                <option disabled selected>
                  وضعیت را انتخاب کنید
                </option>
                {/* <option name={"انتظار بررسی"} value={"انتظار بررسی"}>
              انتظار بررسی
            </option> */}
                <option name={"نیاز به ویرایش"} value={"نیاز به ویرایش"}>
                  نیاز به ویرایش
                </option>
                {history?.data.find((item) => item.program_report !== null) && (
                  <option name={"تایید شده"} value={"تایید شده"}>
                    تایید شده
                  </option>
                )}
              </select>
            </div>
            {errors.status && (
              <p className="text-red-600 text-xs">{errors.status}</p>
            )}
            <button
              onClick={submitForm}
              className="md:w-[40%] w-full py-4 text-white bg-blue-500 flex justify-center gap-2 rounded-lg self-center mt-2"
            >
              <span>ثبت وضعیت</span>
              <Loading isLoading={adminReplyLoading} />
            </button>
          </div>
        )}
        {/* sec 3 */}
        <div className="w-full max-w-[900px] mx-auto space-y-8">
          {history?.data?.map((item, index) => {
            return (
              <HistoryItem
                key={index}
                {...item}
                programTypeList={programTypeList?.data ?? []}
                subjectList={subjectList?.data ?? []}
                activityList={activityList?.data ?? []}
                programNameList={programNameList?.data ?? []}
              />
            );
          })}
        </div>
      </div>
    </MainLayout>
  );
};

export default ProgramDetailPage;
